import dynamic from 'next/dynamic'

export const DynamicOrderItemSkeleton = dynamic(() =>
	import('./OrderItemSkeleton').then(({ OrderItemSkeleton }) => OrderItemSkeleton)
)
